import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Dropdown/DropdownAnatomy.mdx";
import Usage from "../../Docs/Components/Dropdown/DropdownUsage.mdx";

import Examples from "../../Docs/Components/Dropdown/DropdownExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Dropdown"
            description="Dropdowns allow selecting one or more items from a list."
            apiSources={["azure-devops-ui/Components/Dropdown/Dropdown.Props.d.ts", "azure-devops-ui/Components/ListBox/ListBox.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;